import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TurnosMedicoGuard implements CanActivate {
  

  //
  constructor(
    private router: Router
  ) { }


  //
  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) : Promise<boolean | UrlTree> {
    if(Number(localStorage.getItem('turno_habilitado')) == 1){
      return true;
    }
    else {
      this.router.navigate(['/seccion-medico/home-medico']);
      return false; 
    }
  }
  
}
